import React from "react";
import { cn } from "@/lib/utils";
import { Button } from "./button";
import { Spinner } from "@/components/ui/spinner";

type Props = React.ComponentProps<typeof Button> & {
  isSubmitting: boolean;
};

export function SubmitButton({
  className,
  children,
  isSubmitting,
  disabled,
  ...props
}: Props) {
  return (
    <Button
      className={cn("relative", className)}
      {...props}
      disabled={disabled || isSubmitting}
    >
      {isSubmitting && (
        <div className="absolute inset-0 flex items-center justify-center">
          <Spinner size="sm" variant="inverted" />
        </div>
      )}
      <span className={cn(isSubmitting && "invisible")}>{children}</span>
    </Button>
  );
}
